/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Field_Secrets_Hint_AddInputs */



/**
* | output |
* | --- |
* | "The connector's own credentials, such as its OAuth client. After saving, the list shows which secrets the package declares." |
*
* @param {Partner_Connectors_Field_Secrets_Hint_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_field_secrets_hint_add = /** @type {((inputs?: Partner_Connectors_Field_Secrets_Hint_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Field_Secrets_Hint_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die eigenen Zugangsdaten des Konnektors, etwa sein OAuth-Client. Nach dem Speichern zeigt die Liste, welche Secrets das Paket deklariert.")
	return /** @type {LocalizedString} */ ("The connector's own credentials, such as its OAuth client. After saving, the list shows which secrets the package declares.")
});